
import { CompanyModule } from "@/models/company-module";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";
import {ModuleOnlineBackup} from "@/models/module-online-backup-meta-data";
import { CompanyService } from "@/services/company-service";
import { Company } from "@/models/company";

export default FormLike.extend({
	data(){
		return {
			lastBackupDate: null as null | Date,
			today: new Date()
		};
	},
	props: {
		value: {
			type: Object as ()=>CompanyModule,
			required: true
		},
		company: {
			type: Object as ()=>Company,
			required: true
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				let metadata = ModuleOnlineBackup.create(this.value.metaData);
				this.lastBackupDate = metadata.getLastBackupDate();
			}
		}
	},
	methods: {
		cancel(){
			this.$emit("close");
		},
		async submit(){
			if (!this.isValid) return;
			ModuleOnlineBackup.create(this.value.metaData).setLastBackupDate(this.lastBackupDate);
			await CompanyService.updateModuleOfCompany(this.company, this.value.id, this.value.metaData);
			this.$emit("saved", this.value);
			this.$emit("close");
		}
	},
});
